(function () {
  function slugify(text) {
    return String(text || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function getScrollOffset(root) {
    var sticky = getComputedStyle(root).getPropertyValue('--npp-sticky-top').trim();
    return parseInt(sticky, 10) || 120;
  }

  function scrollToId(root, id) {
    var target = document.getElementById(id);
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.scrollY - getScrollOffset(root) - 8;
    window.scrollTo({ top: top, behavior: 'smooth' });
    if (history.replaceState) history.replaceState(null, '', '#' + id);
  }

  function isMediaNode(node) {
    if (!node || node.nodeType !== 1) return false;
    var tag = node.tagName;
    if (tag === 'IMG' || tag === 'FIGURE' || tag === 'PICTURE' || tag === 'VIDEO' || tag === 'IFRAME') {
      return true;
    }
    if (node.querySelector && node.querySelector('img, picture, video, iframe, .video-wrapper, .media')) {
      // Paragraph wrapping only an image/video counts as media block
      var clone = node.cloneNode(true);
      clone.querySelectorAll('img, picture, video, iframe, script, style, br').forEach(function (el) {
        el.remove();
      });
      var leftover = (clone.textContent || '').replace(/\s+/g, ' ').trim();
      return leftover === '';
    }
    return false;
  }

  function extractMedia(node) {
    if (!node) return null;
    if (node.tagName === 'IMG' || node.tagName === 'FIGURE' || node.tagName === 'PICTURE' || node.tagName === 'VIDEO') {
      return node;
    }
    var img = node.querySelector('img, picture, video, iframe');
    if (img && (img.tagName === 'IFRAME' || img.closest('iframe'))) {
      return null; // keep videos full-width in flow
    }
    if (img && (img.tagName === 'IMG' || img.tagName === 'PICTURE' || img.tagName === 'VIDEO')) {
      return node.tagName === 'P' || node.tagName === 'DIV' || node.tagName === 'FIGURE' ? node : img;
    }
    return null;
  }

  function buildSideBySide(body) {
    var headings = Array.from(body.querySelectorAll(':scope > h2'));
    headings.forEach(function (h2) {
      var nodes = [];
      var mediaNode = null;
      var cursor = h2.nextSibling;

      while (cursor) {
        if (cursor.nodeType === 1 && cursor.tagName === 'H2') break;
        if (cursor.nodeType === 1 && cursor.classList && cursor.classList.contains('npp-split')) break;

        if (cursor.nodeType === 1) {
          var media = extractMedia(cursor);
          if (media && !mediaNode && !cursor.querySelector('iframe')) {
            // Prefer image that sits after some text under this H2
            if (nodes.length > 0) {
              mediaNode = cursor;
              break;
            }
          }
          nodes.push(cursor);
        } else if (cursor.nodeType === 3 && cursor.textContent.trim()) {
          nodes.push(cursor);
        }

        cursor = cursor.nextSibling;
      }

      if (!mediaNode || nodes.length === 0) return;

      var split = document.createElement('div');
      split.className = 'npp-split';

      var textCol = document.createElement('div');
      textCol.className = 'npp-split__text';

      var mediaCol = document.createElement('div');
      mediaCol.className = 'npp-split__media';

      h2.parentNode.insertBefore(split, h2);
      textCol.appendChild(h2);
      nodes.forEach(function (n) {
        textCol.appendChild(n);
      });
      mediaCol.appendChild(mediaNode);
      split.appendChild(textCol);
      split.appendChild(mediaCol);
    });
  }

  function enhanceMedia(body) {
    body.querySelectorAll('img').forEach(function (img) {
      if (!img.getAttribute('loading')) img.setAttribute('loading', 'lazy');
      if (!img.getAttribute('decoding')) img.setAttribute('decoding', 'async');
      img.classList.add('npp-content-img');
    });

    body.querySelectorAll('iframe').forEach(function (iframe) {
      var parent = iframe.parentElement;
      if (parent && parent.classList.contains('npp-video')) return;
      var wrap = document.createElement('div');
      wrap.className = 'npp-video';
      iframe.parentNode.insertBefore(wrap, iframe);
      wrap.appendChild(iframe);
    });

    body.querySelectorAll('video').forEach(function (video) {
      video.setAttribute('controls', '');
      video.classList.add('npp-content-video');
    });
  }

  function buildToc(root) {
    var body = root.querySelector('[data-npp-body]');
    var toc = root.querySelector('[data-npp-toc]');
    var tocList = root.querySelector('[data-npp-toc-list]');
    if (!body || !toc || !tocList) return;

    var used = {};
    var items = [];

    var faqEl = root.querySelector('[data-npp-faq]');
    var faqTitleText = '';
    if (faqEl) {
      var faqTitle = faqEl.querySelector('.npp-faq__title');
      faqTitleText = ((faqTitle && faqTitle.textContent) || 'FAQ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
      if (!faqEl.id) faqEl.id = 'frequently-asked-questions';
    }

    body.querySelectorAll('h2').forEach(function (h2) {
      var text = (h2.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) return;

      // Skip recommendation block headings (Related guides / You may also like)
      if (h2.closest && h2.closest('[data-npp-recs]')) return;

      // Prefer metafield FAQ block over a duplicate H2 in page content
      if (faqEl && text.toLowerCase() === faqTitleText) {
        h2.classList.add('npp-heading');
        return;
      }

      var base = slugify(text) || 'section';
      var id = h2.id || base;
      var n = 1;
      while (used[id] || (document.getElementById(id) && document.getElementById(id) !== h2)) {
        n += 1;
        id = base + '-' + n;
      }
      used[id] = true;
      h2.id = id;
      h2.classList.add('npp-heading');
      items.push({ id: id, text: text });
    });

    if (faqEl) {
      var faqLabel = (faqEl.querySelector('.npp-faq__title') && faqEl.querySelector('.npp-faq__title').textContent.trim()) || 'Frequently asked questions';
      items.push({ id: faqEl.id, text: faqLabel });
    }

    if (items.length < 1) {
      toc.hidden = true;
      return;
    }

    tocList.innerHTML = '';
    items.forEach(function (item) {
      var li = document.createElement('li');
      li.className = 'npp-toc__item';
      var a = document.createElement('a');
      a.className = 'npp-toc__link';
      a.href = '#' + item.id;
      a.textContent = item.text;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        scrollToId(root, item.id);
      });
      li.appendChild(a);
      tocList.appendChild(li);
    });

    toc.hidden = false;

    var hash = window.location.hash ? window.location.hash.slice(1) : '';
    if (hash && document.getElementById(hash)) {
      requestAnimationFrame(function () {
        scrollToId(root, hash);
      });
    }
  }

  function placeRecsBeforeFinalThoughts(root) {
    var recs = root.querySelector('[data-npp-recs]');
    if (!recs) return;

    var body = root.querySelector('[data-npp-body]');
    if (!body) return;

    var target = null;
    body.querySelectorAll('h2').forEach(function (h2) {
      if (h2.closest && h2.closest('[data-npp-recs]')) return;
      var text = (h2.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (text.indexOf('final thought') === 0) target = h2;
    });

    if (target) {
      var insertBefore = target;
      var split = target.closest && target.closest('.npp-split');
      if (split && split.parentNode === body) insertBefore = split;
      body.insertBefore(recs, insertBefore);
      return;
    }

    body.appendChild(recs);
  }

  function initRoot(root) {
    if (!root || root.dataset.nppReady === 'true') return;
    var body = root.querySelector('[data-npp-body]');
    if (body) {
      enhanceMedia(body);
      buildSideBySide(body);
      placeRecsBeforeFinalThoughts(root);
    }
    buildToc(root);
    root.dataset.nppReady = 'true';
  }

  function init() {
    document.querySelectorAll('[data-npp-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-npp-root]');
    if (root) {
      root.dataset.nppReady = 'false';
      initRoot(root);
    }
  });
})();
